import * as React from 'react';
import { Loader } from '@topconagriculture/loader';
import { compose, pure } from 'recompose';
const Loading = (props) => {
    const { className: classNameProp, children, size = 60, isLoading, ...others } = props;
    return isLoading ? React.createElement(Loader, Object.assign({ size: size, className: classNameProp }, others)) : React.createElement(React.Fragment, null, children);
};
const ComposedLoading = compose(pure)(Loading);
ComposedLoading.displayName = 'Loading';
export default ComposedLoading;
//# sourceMappingURL=Loading.js.map